export default __webpack_public_path__ + "static/media/JPN.1ca5a40c.svg";